import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getMoods, getTempos } from "../../actions/user";
import useAuth from "../../hooks/useAuth";
import { StoreState } from "../../types/models/store";
import SearchTrack from "../tracks/all-tracks/SearchTrack";
import { Backend } from "shared-types";
import { Genre } from "./../../actions";

export const TrackLayout: React.FC<any> = (props) => {
  const { track_filter } = useSelector((state: StoreState) => state.auth);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useAuth() as any;
  const [genreList, setGenreList] = useState<Backend.T_Genre[]>([]);
  const [moodList, setMoodList] = useState<Backend.T_Mood[]>([]);
  const [tempoList, setTempoList] = useState<Backend.T_Tempo[]>([]);

  const {
    pageClass = "",
    pageTitle = "",
  } = props;

  useEffect(() => {
    getMoods().then((data) => {
      setMoodList(data);
    });
    Genre.all().then((data) => {
      setGenreList(data);
    });
    getTempos().then((data) => {
      setTempoList(data);
    });
  }, []);

  useEffect(() => {
  }, [user]);

  const searchHandle = () => {
    navigate('/all-tracks');
  };

  const resetHandle = () => {
    dispatch({
      type: "SET_TRACK_FILTER",
      payload: {
        ...track_filter,
        artist: [],
        composer: [],
        tempo: [],
        genre: [],
        mood: [],
        keyword: ""
      },
    });
    searchHandle();
  };

  return (
    <>
      <div className={`page ${pageClass}`}>
        <SearchTrack
          data={{
            loading: "",
            title: pageTitle,
            genreList: track_filter.genre === -1 ? genreList : genreList.filter((g: any) => track_filter.genre.indexOf(g.id) !== -1),
            genreCount: genreList.length,
            moodList: track_filter.mood === -1 ? moodList : moodList.filter((g: any) => track_filter.mood.indexOf(g.id) !== -1),
            moodCount: moodList.length,
            tempoList: track_filter.tempo === -1 ? tempoList : tempoList.filter((g: any) => track_filter.tempo.indexOf(g.id) !== -1),
            tempoCount: tempoList.length,
            filtered_artist_list: -1,
            filtered_composer_list: -1,
            handleSearch: searchHandle,
            handleReset: resetHandle,
          }}
        />
        {props.children}
      </div>
    </>
  );
};

export default TrackLayout;
